import { queryOptions } from '@tanstack/react-query';

import { apiKeysApi } from './apiKeys.api';

export const apiKeysOptions = {
  all: () => ['profile', 'apiKeys'] as const,

  list: () =>
    queryOptions({
      queryKey: apiKeysOptions.all(),
      queryFn: apiKeysApi.fetchAll
    })
};
